import React, { Component } from 'react';
import axios from 'axios';
import { ROOT_API_URL } from "../../../../../api-config";
import { auth } from '../../../../../services';
import { history } from '../../../../../helpers/history';

import './Magazine.scss';

class Magazine extends Component {

    constructor(props) {
        super(props);

        this.state = {
            listOfArchives: [],
            latestArchive: {}
        }
    }

    componentDidMount() {
        this.getArchives();
    }

    getArchives() {
        axios.get(
            `${ROOT_API_URL}/Archive/GetArchives`,
            {
                headers: auth.authHeader()
            }
        ).then((response) => {

            this.setState({
                listOfArchives: response.data
            });

            //let count = 0;

            //console.log(JSON.stringify(response.data));

            let archives = response.data;

            archives.sort(function (a, b) {
                return b.year - a.year || b.month - a.month;
            });

            //console.log(JSON.stringify(archives[0]));

            this.setState({
                latestArchive: archives[0]
            });
            //response.data.forEach((element, key) => {
            //    if (!this.state.Years.some(item => item.description === element.year)) {
            //        this.setState({
            //            Years: [...this.state.Years, { id: count, description: element.year }]
            //        });
            //    }
            //    count++;
            //});

            //this.setState({
            //    Years: [...this.state.Years.sort((a, b) => a.description < b.description)]
            //});
        }).catch((response) => {
            console.log(response);
            //history.push('/oops');
        });
    }


    render() {
        return (
            <div className="magazineContainer">
                {
                    this.state.listOfArchives.length > 0 && this.state.latestArchive.image ?
                    <h3 className="main-title">
                        View your latest Magazine edition of {this.state.latestArchive.title} <a className="black-underscore" target="_blank" href={this.state.latestArchive.magazineUrl}>here</a>
                    </h3>
                    :
                    ''
                }
                {
                    this.state.listOfArchives.length > 0 ?
                        (
                            this.state.latestArchive.image ?
                            <a target="_blank" href={this.state.latestArchive.magazineUrl}>
                                <img src={this.state.latestArchive.image} className="productImage" />
                            </a>
                            :
                            <img src="/images/TSCRABackgroundLOGO.png" className="defaultImgHeight" alt="..." />
                        )
                        :
                        ''
                }
                <h3 className="d-none main-title">View prior Magazine editions <a className="black-underscore" target="_blank" href="https://resource.tscra.org/digitalarchives/">here</a></h3>
			</div>
		);
	}
}

export default Magazine;
